// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pkgw-nRt5vg{animation:pkgw-rJUKj5 .3s ease-out}@keyframes pkgw-rJUKj5{0%{opacity:0}100%{opacity:1}}`, "",{"version":3,"sources":["webpack://./src/components/common/DynamicTexts/DynamicTexts.module.scss"],"names":[],"mappings":"AAAA,aACE,kCAAA,CAGF,uBACE,GACE,SAAA,CAEF,KACE,SAAA,CAAA","sourcesContent":[".text {\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `pkgw-nRt5vg`,
	"fadeIn": `pkgw-rJUKj5`
};
export default ___CSS_LOADER_EXPORT___;
